import UAParser from 'ua-parser-js';
const isBraveBrowser = () => {
    return !!navigator?.brave ?? false;
};
const isChrome = () => {
    const ua = new UAParser(navigator.userAgent).getResult();
    return ua.browser.name?.toLowerCase() === 'chrome' && !isBraveBrowser();
};
const isEdge = () => {
    const ua = new UAParser(navigator.userAgent).getResult();
    return ua.browser.name?.toLowerCase() === 'edge';
};
const browserEligibility = () => {
    return isChrome() || isEdge();
};
const isLowMemory = () => {
    return navigator?.deviceMemory < 4;
};
const isWebGL2Supported = () => {
    if ('isWebGL2Supported' in window) {
        return window['isWebGL2Supported'];
    }
    const options = {
        alpha: true,
        antialias: true,
        premultipliedAlpha: true,
        preserveDrawingBuffer: false,
        stencil: true,
    };
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl2', options);
    if (gl && 'getExtension' in gl) {
        gl.getExtension('WEBGL_lose_context')?.loseContext();
    }
    window['isWebGL2Supported'] = !!gl;
    return !!gl;
};
const _isAbsoluteClassicEligible = () => browserEligibility() &&
    (isLowMemory() ||
        !isWebGL2Supported());
const _isForcedClassicEditor = () => localStorage.getItem('editorOverride') === 'classic';
export const isClassicEligible = () => {
    return _isForcedClassicEditor() || _isAbsoluteClassicEligible();
};
